import { Box, Button, Icon } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaMicrosoft } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { authService } from "../../../config";
import { validateReturnTo } from "../returnTo";

export const AzureLoginButton = () => {
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const returnTo = validateReturnTo(searchParams.get("return_to"));

  const login = async () => {
    setIsLoggingIn(true);
    await authService.signupWithAzureAD(returnTo ? window.location.origin + returnTo : undefined);
    setIsLoggingIn(false);
  };

  return (
    <Box w="100%" pt="25px" pb="15px">
      <Button
        leftIcon={<Icon as={FaMicrosoft} w="15px" h="15px" />}
        variant={"outline"}
        isLoading={isLoggingIn}
        colorScheme="teal"
        w="100%"
        onClick={login}
      >
        {t("Log in with Entra ID")}
      </Button>
    </Box>
  );
};
